<template>
  <div class="box is-centered wrapper-rep-receiver">
    <div
      class="modal"
      :class="{ 'is-active': modal }"
    >
      <div class="modal-background" />
      <div class="modal-content">
        <Component
          :is="component"
          @close="onCloseModal()"
        />
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="onCloseModal"
      />
    </div>
    <div class="title-container is-flex">
      <h1 class="title is-centered is-4 has-text-primary title-rep-receiver">
        Detalles de Receptor
      </h1>
    </div>

    <div class="columns">
      <div
        class="column"
        :class="{ 'is-5': !inline, 'is-4': inline }"
      >
        <CustomerSearcherByEmail
          id="email"
          ref="inputEmail"
          label="Email del cliente"
          name="email"
          :value="email"
          :disabled="isLoading || disabled"
          :required="true"
          @select="openModal('InvoiceList')"
        />
      </div>

      <div
        class="column"
        :class="{ 'is-5': !inline, 'is-4': inline }"
      >
        <AppInputField
          id="name"
          name="name"
          label="Nombre del cliente:"
          :value="name"
          placeholder="Nombre Apellido"
          :required="true"
          :disabled="isLoading || disabled"
          @input="onChangeUser"
          @change="onChangeUser"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'DocumentRelatedDetails',
  components: {
    AppSelectField: () => import(/* webpackChunkName: "app-select-field" */ '@/components/AppSelectField.vue'),
    AppSelectSearch: () => import(/* webpackChunkName: "app-select-search" */ '@/components/AppSelectSearch.vue'),
    AppInputField: () => import(/* webpackChunkName: "app-input-field" */ '@/components/AppInputField.vue'),
    CustomerSearcherByEmail: () => import(/* webpackChunkName: "customer-searcher-by-email" */ '@/components/Admin/Customer/SearcherByEmail.vue'),
    InvoiceList: () => import(/* webpackChunkName: "invoice-list" */ '@/components/Admin/Invoices/NewDocumentRelated/InvoiceList.vue'),
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modal: false,
      component: '',
    };
  },
  computed: mapState({
    email: state => state.users.email,
    name: state => state.users.name,
    receiverRfc: state => state.invoice.receiverRfc,
  }),
  methods: {
    ...mapMutations({
      setVoucherValue: 'invoice/setValue',
      setUserValue: 'users/setValue',
      setValue: 'invoices/setValue',
    }),
    ...mapActions({ search: 'invoices/search' }),

    async openModal(component) {
      this.setValue({ accessor: 'all', value: [] });
      this.setValue({ accessor: 'list', value: [] });
      this.component = component;
      this.modal = true;
    },
    onCloseModal() {
      this.modal = false;
      this.component = '';
    },
    onChange(event) {
      const { name: accessor, value } = event.target;
      this.setVoucherValue({ accessor, value });
    },
    onChangeCurrency(event) {
      const { name: accessor, value } = event.target;
      this.setVoucherValue({ accessor, value });
      this.otherCurrency = value !== 'MXN';
    },
    onChangeUser(event) {
      const { name: accessor, value } = event.target;
      this.setUserValue({ accessor, value });
    },
  },
};
</script>

<style scoped>
.box {
  flex-direction: column;
}

.detail-text {
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
  padding: 5px 20px;
  border-radius: 5px;
  color:inherit;
  font-weight: bold;
  float: left;
  clear: both;
}

.float-left {
  float: left;
}

.label.is-centered::before {
  top: inherit;
}

.title {
  margin: 0;
}

.is-checkradio[type="checkbox"] + label::after,
.is-checkradio[type="checkbox"] + label:after {
  width: 0.4rem;
  height: .95rem;
  top: 0.405rem;
  left: 0.6rem;
}

.is-checkradio[type="radio"] + label::before,
.is-checkradio[type="radio"] + label:before,
.is-checkradio[type="checkbox"] + label::before,
.is-checkradio[type="checkbox"] + label:before {
  top: unset;
}

.title-container {
  width: 100%;
  align-items: center;
  padding-bottom: .3rem;
  justify-content: space-between;
}

.columns {
  width: 100%;
}
</style>
